<template>
    <div>
        <TitleHeader />  
    </div>

    <h3 class="text-xl text-gray-800 mt-8 mb-4 font-bold">Paginação</h3>

    <div>
      <Breadcrumb />
    </div>
    
    <div>
      <Back />
    </div>

</template>

<script>

import TitleHeader from "@/Components/UI/TitleHeader.vue"
import Breadcrumb from "@/Components/UI/Breadcrumb.vue"
import Back from "@/Components/UI/Back.vue"
export default {
  components: { TitleHeader, Breadcrumb, Back },
  data() {
    return {
      TitleHeader,
      Breadcrumb,
      Back,
    };
  },
};
</script>